export default "__VITE_ASSET__D3b05Wns__"